import { useQuery } from '@tanstack/react-query';
import { getStoresApi } from '../utils/apis';

export const useStores = (tenantName: string) => {
  const { data, isPending: storesListLoading } = useQuery({
    queryKey: ['stores', tenantName],
    queryFn: () => getStoresApi(tenantName || ''),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!tenantName,
  });

  return { data, storesListLoading };
};
